import type { PickActions } from '@core/ngrx-legacy';
import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { DataSourceListItem } from '@core/views-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<DataSourceListItem[]>()('DataSourceList');

export const DataSourceListActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  selectors as DataSourceListSelectors,
  reducer as DataSourceListReducer,
  namespace as DataSourceListNamespace,
};
